import * as PIXI from "pixi.js";
import { ColorOverlayFilter } from 'pixi-filters';

export default class Scribe extends PIXI.Container {

    private readonly renderer: PIXI.Renderer | PIXI.AbstractRenderer;
    private readonly offset: boolean;
    private readonly easel = new PIXI.Graphics();
    private readonly eraserMask = new PIXI.Graphics();

    private srcSprite: PIXI.Sprite;
    private srcTexture: PIXI.Texture;
    private dstTexture: PIXI.RenderTexture;

    constructor(renderer: PIXI.Renderer | PIXI.AbstractRenderer, offset: boolean) {
        super();
        this.name = 'Scribe';
        this.renderer = renderer;
        this.offset = offset;

        this.srcTexture = PIXI.Texture.WHITE;
        this.srcSprite  = new PIXI.Sprite(this.srcTexture);
        this.dstTexture = PIXI.RenderTexture.create({ width: this.srcSprite.width, height: this.srcSprite.height });
    }

    /**
     * Получить результирующую текстуру
     */
    public get texture() {
        return this.dstTexture;
    }

    /**
     * Установить спрайт - источник текстуры
     * @param sprite
     */
    public set src(sprite: PIXI.Sprite) {
        this.srcSprite = sprite;
        this.srcSprite.filters = [];
        this.srcTexture = sprite.texture;
        this.dstTexture = PIXI.RenderTexture.create({ width: sprite.width, height: sprite.height });

        if (this.offset) {
            this.srcSprite.position.set(this.srcSprite.width/2, this.srcSprite.height/2);
        }
        this.renderObj(this.srcSprite, true);

        this.addChild(this.eraserMask);
        this.srcSprite.mask = this.eraserMask;

        const maskSprite = new PIXI.Sprite(sprite.texture);
        maskSprite.filters = [new ColorOverlayFilter(0xffffff)];
        const maskTexture = PIXI.RenderTexture.create({ width: sprite.width, height: sprite.height });
        this.renderer.render(maskSprite, { renderTexture: maskTexture });
        const mainMask = new PIXI.Sprite(maskTexture);
        this.easel.addChild(mainMask);
        this.easel.mask = mainMask;
    }

    /**
     * Рендер граф. объекта на текстуру
     * @param obj
     * @param clear
     */
    public renderObj(obj: PIXI.IRenderableObject, clear = false) {
        this.renderer.render(obj, { renderTexture: this.dstTexture, clear: clear });
    }

    /**
     * Рисование на текстуре по скрипту
     * @param actions
     * @param scale
     */
    public drawScript(actions: Array<any>, scale = 1) {
        actions.forEach((act: any) => {

            if ('Brush' === act.name && act.points.length > 1) {
                this.easel.clear().lineStyle({
                    cap:  PIXI.LINE_CAP.ROUND,
                    join: PIXI.LINE_JOIN.ROUND,
                    color: act.color,
                    width: act.size / scale,
                });
                for (let i = 1; i < act.points.length; ++i) {
                    const d0 = act.points[i - 1], d1 = act.points[i];
                    this.easel
                        .moveTo(d0.x / scale, d0.y / scale)
                        .lineTo(d1.x / scale, d1.y / scale);
                }
                this.renderObj(this.easel);
            }

            else if ('Text' === act.name) {
                const textStyle = new PIXI.TextStyle({
                    align: 'center',
                    fill: act.color,
                    // fontFamily: 'Arial',
                    fontSize: act.size / scale,
                    fontWeight: 'bold',
                    stroke: 0xffffff,
                    strokeThickness: 1,
                    lineJoin: 'round'
                });
                const pixiText = new PIXI.Text(act.text, textStyle);
                pixiText.anchor.set(0.5);
                pixiText.position.set(act.x / scale, act.y / scale);
                pixiText.angle = act.angle;
                this.renderObj(pixiText);
            }

            else if ('Eraser' === act.name && act.points.length > 1) {
                this.eraserMask.clear().lineStyle({
                    cap:  PIXI.LINE_CAP.ROUND,
                    join: PIXI.LINE_JOIN.ROUND,
                    color: 0xffffff,
                    width: act.size / scale,
                });
                for (let i = 1; i < act.points.length; ++i) {
                    const d0 = act.points[i - 1], d1 = act.points[i];
                    this.eraserMask
                        .moveTo(d0.x / scale, d0.y / scale)
                        .lineTo(d1.x / scale, d1.y / scale);
                }
                this.renderObj(this.srcSprite);
            }

        });
    }

}
